import MonthlyReportsService from 'src/modules/monthlyReports/monthlyReportsService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'MONTHLYREPORTS_VIEW';

const monthlyReportsViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: monthlyReportsViewActions.FIND_STARTED,
      });

      const record = await MonthlyReportsService.find(id);

      dispatch({
        type: monthlyReportsViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: monthlyReportsViewActions.FIND_ERROR,
      });

      getHistory().push('/monthly-reports');
    }
  },
};

export default monthlyReportsViewActions;
